var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartiesCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18965 15.4059H1.82961C1.55939 15.4054 1.34045 15.1865 1.33997 14.9163V14.5191C1.34335 13.3889 2.259 12.4736 3.38923 12.4707H6.63002C7.76025 12.4736 8.6759 13.3889 8.67929 14.5191V14.9163C8.6788 15.1865 8.45987 15.4054 8.18965 15.4059Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.32042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00891 10.5625C3.91561 10.5625 3.02892 9.677 3.02747 8.58371C3.02602 7.49041 3.91036 6.60254 5.00365 6.59962C6.09694 6.59671 6.98599 7.47986 6.99038 8.57315C6.99201 9.09989 6.78402 9.60565 6.4123 9.97886C6.04058 10.3521 5.53566 10.5621 5.00891 10.5625Z",
    fill: "#3158F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5097 15.4059H16.1497C15.8795 15.4054 15.6605 15.1865 15.66 14.9163V14.5191C15.6634 13.3889 16.5791 12.4736 17.7093 12.4707H20.9501C22.0803 12.4736 22.996 13.3889 22.9994 14.5191V14.9163C22.9989 15.1865 22.7799 15.4054 22.5097 15.4059Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.32042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.329 10.5625C18.2357 10.5625 17.349 9.677 17.3475 8.58371C17.3461 7.49041 18.2304 6.60254 19.3237 6.59962C20.417 6.59671 21.3061 7.47986 21.3105 8.57315C21.3121 9.09989 21.1041 9.60565 20.7324 9.97886C20.3606 10.3521 19.8557 10.5621 19.329 10.5625Z",
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9993 20.5H6.00072C5.44845 20.4988 5.00099 19.9767 5 19.3323V18.3851C5.00692 15.6897 6.87831 13.5069 9.18826 13.5H15.8117C18.1217 13.5069 19.9931 15.6897 20 18.3851V19.3323C19.999 19.9767 19.5516 20.4988 18.9993 20.5Z",
    fill: "#3158F2",
    stroke: "#F1F4F8",
    strokeWidth: 2.74203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9648 19.5485H7.12732C6.66686 19.5476 6.29379 19.1746 6.29297 18.7141V18.0373C6.29874 16.1114 7.85901 14.5518 9.78492 14.5469H15.3072C17.2331 14.5518 18.7934 16.1114 18.7992 18.0373V18.7141C18.7984 19.1746 18.4253 19.5476 17.9648 19.5485Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5444 12.2958C10.6814 12.2958 9.17045 10.7868 9.16797 8.92387C9.1655 7.0609 10.6724 5.54796 12.5354 5.54298C14.3984 5.53803 15.9133 7.04292 15.9208 8.90588C15.9235 9.80345 15.5691 10.6653 14.9357 11.3012C14.3023 11.9372 13.4419 12.295 12.5444 12.2958Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiesCheck);
export default __webpack_public_path__ + "static/media/parties_check.26e021e8cb1f5858782dccf7dbc2fe0a.svg";
export { ForwardRef as ReactComponent };